import React from "react";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, isAuthenticated, isClientSelected, ...children }) => {
  if(!isAuthenticated) {
    return <Redirect to="/login" />
  }

  if(!isClientSelected) {
    return <Redirect to="/client-chooser" />
  }

  return <Route {...children} render={props => <Component {...props} {...children} />} />
};

export default PrivateRoute;
